export const translations = {
    en: {
        title: "Fraser Robinson",
        subtitle: "Technical Translations",
        years_experience: "20 years of linguistic expertise acquired in four continents",
        about_button: "About",
        services_button: "Services",
        languages_button: "Languages",
        contact_button: "Contact",
        quote_button: "Request a Quote",
        about_title: "Technical Translation Expert",
        about_text: "With two decades of experience, I provide high-precision technical translation services for demanding clients. My methodical approach and sector expertise guarantee impeccable quality results.",
        services_title: "My Services",
        services_text1: "Technical translation",
        services_text2: "Proofreading and editing",
        services_text3: "Linguistic consulting",
        services_text4: "Transcreation",
        languages_title: "Languages",
        language1: "Chinese → English",
        language2: "Portuguese → English",
        language3: "Spanish → English",
        language4: "French → English",
        contact_title: "Contact Me",
        email: "translations@frasererobinson.com",
        proz_text: "Check out my ProZ profile:",
        proz_button: "ProZ Profile",
        footer_text: "Fraser Robinson Traductions",
        quote_title: "Need a quick quote?",
        quote_text: "Get a free estimate for your translation project.",
        forms_title: "Quote Request",
        forms_name: "Full Name *",
        forms_enterprise: "Company",
        forms_email: "Email *",
        forms_phone: "Phone",
        forms_description: "Project Description *",
        forms_file: "Attach file (optional)",
        forms_selected_file: "Selected file:",
        forms_button: "Submit Request",
        modal_success_title: "Request sent successfully!",
        modal_success_message: "I will contact you as soon as possible.",
        modal_close_button: "Close",
        default_error: "An error occurred. Please try again later.",
        network_error: "Connection error. Please check your internet.",
        file_too_large: "File too large (max 5MB)",
        modal_error_title: "Submission Error",
        forms_submitting: "Submitting...",
    },
    fr: {
      title: "Fraser Robinson",
      subtitle: "Traductions Techniques",
      years_experience: "20 ans d'expertise linguistique acquise sur quatre continents",
      about_button: "À Propos",
      services_button: "Services",
      languages_button: "Langues",
      contact_button: "Contact",
      quote_button: "Demander un devis",
      about_title: "Expert en traduction technique",
      about_text: "Fort de deux décennies d'expérience, je propose des services de traduction technique de haute précision pour les clients exigeants. Mon approche méthodique et mon expertise garantissent des résultats d'une qualité irréprochable.",
      services_title: "Mes Services",
      services_text1: "Traduction technique",
      services_text2: "Relecture et révision",
      services_text3: "Conseil linguistique",
      services_text4: "Transcréation",
      languages_title: "Langues",
      language1: "Chinois → Anglais",
      language2: "Portugais → Anglais",
      language3: "Espagnol → Anglais",
      language4: "Français → Anglais",
      contact_title: "Contactez-moi",
      email: "translations@frasererobinson.com",
      proz_text: "Consultez mon profil ProZ:",
      proz_button: "ProZ Profil",
      footer_text: "Fraser Robinson Translations",
      quote_title: "Besoin d'un devis rapidement ?",
      quote_text: "Obtenez une estimation gratuite de votre projet de traduction.",
      forms_title: "Demande de devis",
      forms_name: "Prénom et nom *",
      forms_enterprise: "Entreprise",
      forms_email: "Email *",
      forms_phone: "Téléphone",
      forms_description: "Description du projet *",
      forms_file: "Joindre un fichier (optionnel)",
      forms_selected_file: "Fichier sélectionné:", 
      forms_button: "Envoyer la demande",
      modal_success_title: "Demande envoyée avec succès !",
      modal_success_message: "Je vous contacterai dans les plus brefs délais.",
      modal_close_button: "Fermer",
      default_error: "Une erreur est survenue. Veuillez réessayer plus tard.",
      network_error: "Erreur de connexion. Veuillez vérifier votre internet.",
      file_too_large: "Fichier trop volumineux (max 5MB)",
      modal_error_title: "Erreur d'envoi",
      forms_submitting: "Envoi en cours...",
    },
    pt: {
        title: "Fraser Robinson",
        subtitle: "Traduções Técnicas, Literárias e Acadêmicas",
        years_experience: "20 anos de expertise linguística adquirida em quatro continentes",
        about_button: "Sobre",
        services_button: "Serviços",
        languages_button: "Idiomas",
        contact_button: "Contato",
        quote_button: "Solicitar orçamento",
        about_title: "Especialista em tradução técnica, literária e acadêmica",
        about_text: "Com mais de duas décadas no ramo, forneço serviços de tradução técnica, literária e acadêmica de alta precisão para clientes exigentes como você. Minha abordagem metódica e expertise setorial garantem resultados de qualidade impecável. Graças a minha vasta experiência na área da tradução acadêmica, incluindo de diversos livros que abrangem uma ampla gama de domínios, as minhas traduções vêm com a certeza de que seu artigo ou livro será aceito para publicação.",
        services_title: "Meus Serviços",
        services_text1: "Tradução técnica, literária e acadêmica",
        services_text2: "Revisão e edição",
        services_text3: "Consultoria linguística",
        services_text4: "Transcriação",
        languages_title: "Idiomas",
        language1: "Chinês → Inglês",
        language2: "Português → Inglês",
        language3: "Espanhol → Inglês",
        language4: "Francês → Inglês",
        contact_title: "Entre em Contato",
        email: "translations@frasererobinson.com",
        proz_text: "Consulte meu perfil no ProZ:",
        proz_button: "Perfil ProZ",
        quote_title: "Precisa de um orçamento rápido?",
        quote_text: "Obtenha uma estimativa gratuita para seu projeto de tradução.",
        footer_text: "Fraser Robinson Translations",
        forms_title: "Solicitação de Orçamento",
        forms_name: "Nome completo *",
        forms_enterprise: "Empresa",
        forms_email: "E-mail *",
        forms_phone: "Telefone",
        forms_description: "Descrição do projeto *",
        forms_file: "Anexar arquivo (opcional)",
        forms_selected_file: "Arquivo selecionado:",
        forms_button: "Enviar solicitação",
        modal_success_title: "Solicitação enviada com sucesso!",
        modal_success_message: "Entrarei em contato o mais breve possível.",
        modal_close_button: "Fechar",
        default_error: "Ocorreu um erro. Por favor, tente novamente mais tarde.",
        network_error: "Erro de conexão. Verifique sua internet.",
        file_too_large: "Arquivo muito grande (máx 5MB)",
        modal_error_title: "Erro no Envio",
        forms_submitting: "Enviando...",
      },
      zh: {
        title: "罗万福",
        subtitle: "技术翻译服务",
        years_experience: "在四大洲积累的20年语言专业经验",
        about_button: "关于我",
        services_button: "服务项目",
        languages_button: "多种语言组合",
        contact_button: "联系我",
        quote_button: "获取报价",
        about_title: "专业技术翻译专家",
        about_text: "凭借二十年的翻译经验，我为要求严格的客户提供高精度的技术翻译服务。我系统性的工作方法和行业专业知识确保了无可挑剔的翻译质量。我的目的是精益求精，不断提升我翻译质量，满足客户的需求。",
        services_title: "我的服务",
        services_text1: "技术文档翻译",
        services_text2: "校对与编辑",
        services_text3: "语言咨询",
        services_text4: "创译",
        languages_title: "翻译语言",
        language1: "中文 → 英文",
        language2: "葡萄牙文 → 英文",
        language3: "西班牙文 → 英文",
        language4: "法文 → 英文",
        contact_title: "联系方式",
        email: "translations@frasererobinson.com",
        proz_text: "查看我的ProZ个人资料：",
        proz_button: "ProZ档案",
        quote_title: "需要快速报价？",
        quote_text: "获取您的翻译项目免费估价。",
        footer_text: "Fraser Robinson Translations",
        forms_title: "报价申请",
        forms_name: "姓名 *",
        forms_enterprise: "公司名称",
        forms_email: "电子邮箱 *",
        forms_phone: "联系电话",
        forms_description: "项目描述 *",
        forms_file: "附件文件 (可选)",
        forms_selected_file: "已选择文件：",
        forms_button: "提交申请",
        modal_success_title: "请求发送成功！",
        modal_success_message: "我将尽快与您联系。",
        modal_close_button: "关闭",
        default_error: "发生错误，请稍后再试。",
        network_error: "网络连接错误，请检查您的网络。",
        file_too_large: "文件过大（最大5MB）",
        modal_error_title: "提交错误",
        forms_submitting: "提交中...",
    },
    zh_tw: {
        title: "羅萬福",
        subtitle: "技術翻譯服務",
        years_experience: "在四大洲累積的20年語言專業經驗",
        about_button: "關於我",
        services_button: "服務項目",
        languages_button: "語言",
        contact_button: "聯絡我",
        quote_button: "獲取報價",
        about_title: "專業技術翻譯專家",
        about_text: "憑藉二十年的翻譯經驗，我為要求嚴格的客戶提供高精度的技術翻譯服務。我系統性的工作方法和行業專業知識確保了無可挑剔的翻譯質量。我的目的是精益求精，不斷提升我翻譯質量，滿足顧客的需求。",
        services_title: "我的服務",
        services_text1: "技術文件翻譯",
        services_text2: "校對與編輯",
        services_text3: "語言諮詢",
        services_text4: "文件轉錄",
        languages_title: "翻譯語言",
        language1: "中文 → 英文",
        language2: "葡萄牙文 → 英文",
        language3: "西班牙文 → 英文",
        language4: "法文 → 英文",
        contact_title: "聯絡方式",
        email: "translations@frasererobinson.com",
        proz_text: "查看我的ProZ個人資料：",
        proz_button: "ProZ檔案",
        quote_title: "需要快速報價？",
        quote_text: "獲取您的翻譯項目免費估價。",
        footer_text: "Fraser Robinson Translations",
        forms_title: "報價申請",
        forms_name: "姓名 *",
        forms_enterprise: "公司名稱",
        forms_email: "電子郵箱 *",
        forms_phone: "聯絡電話",
        forms_description: "項目描述 *",
        forms_file: "附件文件 (可選)",
        forms_selected_file: "已選擇文件：",
        forms_button: "提交申請",
        modal_success_title: "請求發送成功！",
        modal_success_message: "我將盡快與您聯絡。",
        modal_close_button: "關閉",
        default_error: "發生錯誤，請稍後再試。",
        network_error: "網路連線錯誤，請檢查您的網路。",
        file_too_large: "檔案過大（最大5MB）",
        modal_error_title: "提交錯誤",
        forms_submitting: "提交中...",
    },
  };